import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {Input, Modal} from "antd";
import {IconClose, IconSearchPdfCard} from "../../Icon";
import {t} from "i18next";
import {
    createEmptyProject,
    generateRandomPageKey,
    getImagePathWithTheme,
    imgPathPerfix,
    isDarkMode,
    isStringNullOrEmpty
} from "../../utils";
import {getNoteDoc, getNoteJsonDoc, getNoteList} from "../../../model/note";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {FROM_LINK_TO_PROJECT, MEDIIUM_Z_INDEX} from "../../Const";
import Icon, {DownOutlined} from "@ant-design/icons";
import DirectoryTree from "antd/es/tree/DirectoryTree";
import {TreeProps} from "antd/es/tree";
import ConfigProvider from "antd/lib/config-provider";
import "./DialogChooseProject.css"
import global from "@/global";
import {filterNodes, loopAllNode} from "@/TreeUtils";
import {debugLog} from "@/LogUtils";
let mArrayAllDatas:any;
let mArraySelectItems:any;
let mLastEnter:any;
let mCallback:any;
let mFrom:any;

const DialogChooseProject = forwardRef((props:{onOkEvent:any,onCloseEvent?:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }));
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [searchKey,setSearchKey] = useState('');
    const [arrayDatas,setArrayDatas] = useState([]);
    const [title,setTitle] = useState(t("Add to project"));
    const inputRef = useRef(null);
    const [arrayTreeData,setArrayTreeData] = useState([]);
    const [fromSource,setFromSource] = useState('');
    const mArrayAllTreeData = useRef<any>(null);

    const onShowDialog = (arraySelectItems:any,szTitle:string,from:any,callback:any)=>{
        mArraySelectItems = arraySelectItems;
        mCallback = callback;
        mFrom = from;
        setFromSource(from);
        if (szTitle){
            setTitle(szTitle);
        }
        setSearchKey('')
        setIsShowDialog(true);

        getNoteList().then(async (res)=>{
            mArrayAllDatas = res;

            var arrayNew:any = [];
            if (from != FROM_LINK_TO_PROJECT){
                arrayNew.push({
                    id:generateRandomPageKey(),
                    showName:t("Create project")+' ""',
                    name:'',
                    isCreateNew:true,
                    isChecked:true
                })
            }
            arrayNew.push(...res);
            setArrayDatas(arrayNew);

            var arrayNewTreeData:any = [];
            if (from != FROM_LINK_TO_PROJECT){
                arrayNewTreeData.push(getCreateNewProject())
            }

            mArrayAllTreeData.current = [];
            for (let i=0;i<res.length;i++){
                const item = res[i];
                const jsonDoc = await getNoteJsonDoc(item.id);
                if (!jsonDoc)continue;
                const treeData = {
                    id:item.id,
                    key:item.id,
                    title:item.name || t('Untitled'),
                    icon:null,
                    isProject:true
                }

                loopAllNode(jsonDoc.canvas,(node)=>{
                    node.id = item.id;
                    node.isChild = true;
                })
                treeData.children = [];
                treeData.children.push(...jsonDoc.canvas);

                // if (jsonDoc.canvas?.length > 1){
                //     treeData.children = [];
                //     for (let j=0;j<jsonDoc.canvas.length;j++){
                //         treeData.children.push({
                //             isChild:true,
                //             id:item.id,
                //             key:jsonDoc.canvas[j].key,
                //             title:jsonDoc.canvas[j].title
                //         })
                //     }
                // }

                arrayNewTreeData.push(treeData);
                mArrayAllTreeData.current.push(treeData);
            }

            setArrayTreeData(arrayNewTreeData);
        })
    }

    /**
     * create new
     */
    function getCreateNewProject(){
        const randomId = generateRandomPageKey();
        const newProject = {
            id:randomId,
            key:randomId,
            title:t("Create project")+' ""',
            icon:null,
            isCreateNew:true,
            isProject:true
        }
        return newProject;
    }

    function onKeyDownEvent(event:any){
        // debugLog('keydown',event);

        if (!isShowDialog)return;
        if (event.key == KEYS.ARROW_DOWN){
            var nIndex = arrayDatas.findIndex(p=>p.isChecked);
            nIndex ++;
            if (nIndex >= arrayDatas.length){
                nIndex = 0;
            }

            var arrayNew = [...arrayDatas];
            arrayNew.forEach(p=>p.isChecked = false);
            arrayNew[nIndex].isChecked = true;
            setArrayDatas(arrayNew);

        }else if (event.key == KEYS.ARROW_UP){
            var nIndex = arrayDatas.findIndex(p=>p.isChecked);
            if (nIndex == 0){
                nIndex = arrayDatas.length;
            }
            nIndex --;
            var arrayNew = [...arrayDatas];
            arrayNew.forEach(p=>p.isChecked = false);
            arrayNew[nIndex].isChecked = true;
            setArrayDatas(arrayNew);
        }
        else if (event.key == KEYS.ENTER){
            event.stopPropagation();

            setTimeout(()=>{
                //当前选中的一个
                const arrayFilters = arrayDatas.filter(p=>p.isChecked);
                if (arrayFilters && arrayFilters.length > 0){
                    arrayFilters[0].name = inputRef.current?.input?.value;
                    if (mCallback){
                        mCallback(arrayFilters[0]);
                    }else{
                        props.onOkEvent(arrayFilters[0],mArraySelectItems);
                    }

                    setIsShowDialog(false);
                }
            },100)

        }
    }

    useEffect(()=>{
        onSetTreeHover();
    },[])

    useEffect(()=>{
        document.body.addEventListener('keydown',onKeyDownEvent);

        return ()=>{
            document.body.removeEventListener('keydown',onKeyDownEvent);
        }
    })

    const onSetTreeHover = ()=>{
        setTimeout(()=>{
            const div = document.getElementById('div-shit-ant-tree');
            if (div){
                const arrayShitTrees = div.getElementsByClassName('ant-tree-list-holder-inner');
                for (let i=0;i<arrayShitTrees.length;i++){
                    const ddddd = arrayShitTrees[i];
                    ddddd.classList.add(isDarkMode()?'ant-tree-list-holder-inner-shit-ant-tree-dark':'ant-tree-list-holder-inner-shit-ant-tree-light')
                }
            }
        },100)
    }

    const onSelect:TreeProps["onSelect"] =(async (selectedKeys:any, info) => {
        console.log(info.node);
        if (!info.node.isProject && (info.node.isFolder || info.node.children))return;

        if (mCallback) {
            mCallback(info.node);
        } else {
            props.onOkEvent(info.node, mArraySelectItems);
        }
        if (props.onCloseEvent){
            props.onCloseEvent();
        }
    });

    return(
        <Modal afterClose={()=>{
            if (props.onCloseEvent) {
                props.onCloseEvent();
            }
        }} zIndex={MEDIIUM_Z_INDEX} width={516} bodyStyle={{minHeight:'400px',fontSize:'12px'}} open={isShowDialog} centered={true}
               afterOpenChange={(open)=>{
                   inputRef.current?.focus();
                   global.g_showDialogs.dialogChooseProject = open;
               }}
               closable={false} closeIcon={<IconClose/>} footer={''}
               onCancel={()=>setIsShowDialog(false)}>
            <div id={'div-shit-ant-tree'}>
                <span className={'dialog-title'} style={{width:'100%',textAlign:'center',display:'block'}}>{title}</span>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

                <Input ref={inputRef}
                       suffix={<img className='img-mini-small-8 cursor-pointer'
                                    style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit",marginRight:'6px'}}
                                    onClick={() => {
                                        setSearchKey('');
                                        setArrayDatas(mArrayAllDatas);
                                        const arrayNewTreeData = [...mArrayAllTreeData.current];
                                        if (mFrom != FROM_LINK_TO_PROJECT) {
                                            const newProject = getCreateNewProject();
                                            arrayNewTreeData.splice(0,0,newProject);
                                        }
                                        setArrayTreeData(arrayNewTreeData);
                                    }}
                                    src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
                       variant={"borderless"}
                       className={'input-border input-card-placeholder default-font-size'}
                       style={{width: '100%', height: '32px',paddingLeft:'12px'}}
                       placeholder={title} value={searchKey}
                       onChange={(event)=>{
                            setSearchKey(event.currentTarget.value);

                            if (fromSource == FROM_LINK_TO_PROJECT || arrayTreeData) {
                                var arrayNewTreeData:any = [];
                                const szKey = event.currentTarget.value.toLowerCase();
                                if (!szKey) {
                                    arrayNewTreeData.push(...mArrayAllTreeData.current);
                                }else {
                                    arrayNewTreeData = filterNodes(mArrayAllTreeData.current,szKey);
                                    // for (let i = 0; i < mArrayAllTreeData.length; i++) {
                                    //     const item = mArrayAllTreeData[i];
                                    //     let newItem:any = null;
                                    //     if (item.title.toLowerCase().includes(szKey)) {
                                    //         newItem = {...item};
                                    //         // delete newItem.children;
                                    //     }else if (item.children) {
                                    //         for (let j=0;j<item.children.length;j++) {
                                    //             if (item.children[j].title.toLowerCase().includes(szKey)) {
                                    //                 if (newItem) {
                                    //                     if (!newItem.children) {
                                    //                         newItem.children = [];
                                    //                     }
                                    //                 }else {
                                    //                     newItem = {...item};
                                    //                     newItem.children = [];
                                    //                 }
                                    //                 newItem.children.push({...item.children[j]})
                                    //             }
                                    //         }
                                    //     }
                                    //     if (newItem) {
                                    //         arrayNewTreeData.push(newItem);
                                    //     }
                                    // }
                                }

                                if (mFrom != FROM_LINK_TO_PROJECT) {
                                    const newProject = getCreateNewProject();
                                    newProject.title = newProject.showName = t("Create project") + ' "' + event.currentTarget.value + '"';
                                    newProject.name = event.currentTarget.value;
                                    arrayNewTreeData.splice(0,0,newProject);
                                }

                                setArrayTreeData(arrayNewTreeData);
                            }else {
                                var arrayNewData = mArrayAllDatas.filter(p => p.name.toLowerCase().indexOf(event.currentTarget.value.toLowerCase()) >= 0);

                                var arrayNew: any = [];
                                if (mFrom != FROM_LINK_TO_PROJECT) {
                                    arrayNew.push({
                                        id: generateRandomPageKey(),
                                        showName: t("Create project") + ' "' + event.currentTarget.value + '"',
                                        name: event.currentTarget.value,
                                        isCreateNew: true,
                                        isChecked: true
                                    });
                                }
                                arrayNew.push(...arrayNewData);
                                setArrayDatas(arrayNew);
                            }
                }}/>

                {
                    (fromSource == FROM_LINK_TO_PROJECT || true)?
                        <ConfigProvider
                            theme={{
                                components: {
                                    Tree: {
                                        /* 这里是你的组件 token */
                                        // nodeHoverBg:'#000000',
                                        colorBgContainer:'#000000'
                                    },
                                },
                            }}
                        >
                            <DirectoryTree
                                style={{
                                    margin: '8px 0 8px 0px',
                                    height: '300px',
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    background: isDarkMode()?'#1E1E1E':'transparent',
                                    border:'1px solid var(--line-color)',
                                    borderRadius:'8px'
                                }}
                                className={'overwrite-direction-tree tree-fuck-css-left-align-2-popupcard-list'}
                                switcherIcon={<Icon component={() => <img className='img-10' style={{marginTop:'2px'}} src={getImagePathWithTheme('tree_icon')}/>}/>}
                                onSelect={onSelect}
                                showIcon={false}
                                treeData={arrayTreeData}
                                selectedKeys={[]}
                                blockNode={true}
                                titleRender={(nodeData: any) => {
                                    return (
                                        <div className='' id={nodeData.key}
                                             style={{display: "flex", width: "450px", alignItems: "center"}}>
                                            <Input className='default-font-size font-family-regular hovered-text-white'
                                                   readOnly={true} bordered={false}
                                                   style={{
                                                       marginLeft: '0px',
                                                       paddingLeft: '0px',
                                                       whiteSpace: 'nowrap',
                                                       textOverflow: 'ellipsis',
                                                       overflow: 'hidden',
                                                       cursor: "pointer",
                                                       fontSize: '14px',
                                                       marginBottom: '0px',
                                                       marginTop: '0px',
                                                   }}
                                                   value={nodeData.title}/>
                                        </div>
                                    )
                                }}
                            />
                        </ConfigProvider>
                        :
                    <div className={'flex-col mt-12 dialog-border-shadow item-border'}
                         style={{height: '320px', marginBottom: '-16px', padding: '12px 0px', overflowY: 'auto'}}>
                        {
                            arrayDatas.map(p => (
                                <div onClick={() => {
                                    if (mCallback) {
                                        mCallback(p);
                                    } else {
                                        props.onOkEvent(p, mArraySelectItems);
                                    }

                                    setIsShowDialog(false);
                                }} onMouseEnter={() => {
                                    var arrayNew = [...arrayDatas];
                                    arrayNew.forEach(p => p.isChecked = false);
                                    p.isChecked = true;
                                    setArrayDatas(arrayNew);
                                    mLastEnter = p;
                                }} onMouseLeave={() => {
                                    var arrayNew = [...arrayDatas];
                                    arrayNew.forEach(p => p.isChecked = false);
                                    if (mLastEnter) {
                                        mLastEnter.isChecked = true;
                                    }
                                    setArrayDatas(arrayNew);
                                }} style={{height: '32px', margin: '0 0px', padding: '0 0px'}}
                                     className={'flex-row-vertical-center hovered-blue'}>
                                    {/*<img className={'img-16'} src={getImagePathWithTheme(chooseType == 'card'?'choose_card_card':'choose_card_pdf')}/>*/}
                                    <span className={'span-single-line'} style={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'block',
                                        color: p.isChecked ? '#FFFFFF' : '',
                                        background: p.isChecked ? '#3670F7' : 'transparent',
                                        padding: '0 16px',
                                        borderRadius: '2px',
                                        lineHeight: '32px'
                                    }}>{p.isCreateNew ? p.showName : (p.name || t("Untitled"))}</span>
                                </div>
                            ))
                        }
                    </div>
                }
            </div>
        </Modal>
    )
});
export default DialogChooseProject;